import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-xl font-heading font-bold text-foreground-900">
              91蜜桃
            </span>
            <span className="hidden sm:inline text-xs text-foreground-600 bg-background-200/70 px-2 py-0.5 rounded-full">
              官方导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-100/70'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}